module.exports = __webpack_public_path__ + "static/media/logo.4dbbacd2.svg";